export default __webpack_public_path__ + "static/media/map4.7f498834.png";